<template>
	<!-- 评价 -->
	<div class="commentBox">
		<van-sticky>
			<div class='header'>
				<div class="header_tit">
					<div class="leftarrImg" @click="$router.back(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<h4>评价</h4>
					<div class="rightSelect" @click="showSelectBox">
						<p v-if="selectValue == 0">全部章节</p>
						<p v-if="selectValue != 0">第{{selectValue}}章</p>
						<img src="../../assets/img/selectArr.png" alt="">
					</div>
					<ul class="selectItem" v-show="showSelect">
						<li v-for="(selectItem,index) in showSelectLists" @click="selectItemFn(selectItem.number,index,selectItem.id)"
						 :class="selectIndex == index ? 'active_color' : '' ">
							<span v-if="selectItem.number == 0">全部章节</span>
							<span v-if="selectItem.number != 0">第{{selectItem.number}}章</span>
						</li>
					</ul>
				</div>
			</div>
			<div class="navBar">
				<div v-for="(navItem,index) in navlists" @click="navActiveFn(index)" :class="navActiveIndex == index ? 'active_navbar' : ''">{{navItem}}</div>
			</div>
		</van-sticky>
		<!-- 最新评论 -->
		<div class="newCommentBox" v-show="navActiveIndex == 0 ? true : false">
			<!-- 实时讨论列表 -->
			<div class="forumListBox" v-if="list_comment.length != 0 ? true : false">
				<div class="forumListItem" v-for='(item,index) in list_comment' v-if="selectValue == item.chapter_num"
				 @touchstart="showDeleteButton(item.id)" @touchend="emptyTime">
					<!-- 头像栏 -->
					<div class="forum_top">
						<div class="forum_top_left">
							<div class="userImg">
								<img :src="$api.$BASE_URL_img+item.avatar" alt="" @click.stop="readUserZlFn(item.user_id)">
								<div class="timeInfo">
									<span class="wname">{{item.nickname}}</span>
									<p><span>{{formatDateTime(item.createtime)}}</span>
										<!-- <span class="time">18:45:26</span> -->
									</p>
								</div>
							</div>
							<!-- <p class="bookName">《笑傲江湖》</p> -->
						</div>
						<div class="forum_top_right">
							<span v-if='item.chapter_num ==0|| item.chapter_num ==null'> </span>
							<span v-if='item.chapter_num'>第<i>{{item.chapter_num}}</i>章</span>
							<span><i>{{item.c_score}}</i>分</span>
						</div>
					</div>

					<div class="forum_middle">
						<p>
							<img src="../../assets/img/ds01.png" alt="" v-if="item.gift == '流星'">
							<img src="../../assets/img/ds02.png" alt="" v-if="item.gift == '卫星'">
							<img src="../../assets/img/ds03.png" alt="" v-if="item.gift == '行星'">
							<img src="../../assets/img/ds04.png" alt="" v-if="item.gift == '恒星'">
							<img src="../../assets/img/ds05.png" alt="" v-if="item.gift == '慧星'">
							<img src="../../assets/img/ds06.png" alt="" v-if="item.gift == 'M78星云'">
							<img src="../../assets/img/ds07.png" alt="" v-if="item.gift == '银河系'">
							{{item.c_content}} </p>
						<img src="../../assets/img/xiaoxi.png" alt="" class="xiaoxi" @click="toReply(item.id,item.user_id,item.nickname,item.c_content)">
					</div>
					<div class="er_reply" v-if="item.child.length == 0 ? false : true">
						<div :class="!item.show_comment ? 'list_item threelist' : 'list_item'" v-for='(it,index1) in item.child' :key='it.id'>
							<p class="top_text">
								<span class="name">{{it.nickname}}</span>
								<span class="floor">{{index1+1}}楼</span>
							</p>
							<p class="time">
								<span class="er_reply_time">{{formatDateTime(it.createtime)}}</span>
							</p>
							<p class="content">{{it.c_content}}</p>
						</div>
					</div>
					<div v-if="item.child.length > 3" @click="showComment(index)" class="more_comment">
						<span>
							{{!item.show_comment ? '更多评论' : '收起评论'}}
						</span>
						<img src="../../assets/img/rightArrs.png" alt="">
					</div>
					<!-- <div class="forum_bottom">
						<div><span>2楼</span> <span>读者甜瓜</span></div>
					</div> -->
				</div>
				<!-- 展示 全部 最新评论 -->
				<div class="forumListItem" v-for='(item,index) in list_comment' :key='index' v-if="selectValue == 0"
				 @touchstart="showDeleteButton(item.id)" @touchend="emptyTime">
					<!-- 头像栏 -->
					<div class="forum_top">
						<div class="forum_top_left">
							<div class="userImg">
								<img :src="$api.$BASE_URL_img+item.avatar" alt="" @click.stop="readUserZlFn(item.user_id)">
								<div class="timeInfo">
									<span class="wname">{{item.nickname}}</span>
									<p><span>{{formatDateTime(item.createtime)}}</span>
										<!-- <span class="time">18:45:26</span> -->
									</p>
								</div>
							</div>
							<!-- <p class="bookName">《笑傲江湖》</p> -->
						</div>
						<div class="forum_top_right">
							<span v-if='item.chapter_num ==0|| item.chapter_num ==null'> </span>
							<span v-if='item.chapter_num'>第<i>{{item.chapter_num}}</i>章</span>
							<span><i>{{item.c_score}}</i>分</span>
						</div>
					</div>

					<div class="forum_middle">
						<p>
							<img src="../../assets/img/ds01.png" alt="" v-if="item.gift == '流星'">
							<img src="../../assets/img/ds02.png" alt="" v-if="item.gift == '卫星'">
							<img src="../../assets/img/ds03.png" alt="" v-if="item.gift == '行星'">
							<img src="../../assets/img/ds04.png" alt="" v-if="item.gift == '恒星'">
							<img src="../../assets/img/ds05.png" alt="" v-if="item.gift == '慧星'">
							<img src="../../assets/img/ds06.png" alt="" v-if="item.gift == 'M78星云'">
							<img src="../../assets/img/ds07.png" alt="" v-if="item.gift == '银河系'">
							{{item.c_content}} </p>
						<img src="../../assets/img/xiaoxi.png" alt="" class="xiaoxi" @click="toReply(item.id,item.user_id,item.nickname,item.c_content)">
					</div>
					<div class="er_reply" v-if="item.child.length == 0 ? false : true">
						<div :class="!item.show_comment ? 'list_item threelist' : 'list_item'" v-for='(it,index1) in item.child' :key='it.id'>
							<p class="top_text">
								<span class="name">{{it.nickname}}</span>
								<span class="floor">{{index1+1}}楼</span>
							</p>
							<p class="time">
								<span class="er_reply_time">{{formatDateTime(it.createtime)}}</span>
							</p>
							<p class="content">{{it.c_content}}</p>
						</div>
					</div>
					<div v-if="item.child.length > 3" @click="showComment(index)" class="more_comment">
						<span>
							{{!item.show_comment ? '更多评论' : '收起评论'}}
						</span>
						<img src="../../assets/img/rightArrs.png" alt="">
					</div>
					<!-- <div class="forum_bottom">
						<div><span>2楼</span> <span>读者甜瓜</span></div>
					</div> -->
				</div>
			</div>
			<div v-else class="data_null">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		<!-- 长楼 -->
		<div class="newCommentBox" v-show="navActiveIndex == 1 ? true : false">
			<div class="forumListBox" v-if="longLou.length != 0 ? true : false">
				<div class="forumListItem" v-for='(item,index) in longLou' :key='index' v-if="selectValue == 0"
				 @touchstart="showDeleteButton(item.id)" @touchend="emptyTime">
					<!-- 头像栏 -->
					<div class="forum_top">
						<div class="forum_top_left">
							<div class="userImg">
								<img :src="$api.$BASE_URL_img+item.avatar" alt="" @click.stop="readUserZlFn(item.user_id)">
								<div class="timeInfo">
									<span class="wname">{{item.nickname}}</span>
									<p><span>{{formatDateTime(item.createtime)}}</span>
										<!-- <span class="time">18:45:26</span> -->
									</p>
								</div>
							</div>
							<!-- <p class="bookName">《笑傲江湖》</p> -->
						</div>
						<div class="forum_top_right">
							<span v-if='item.chapter_num ==0|| item.chapter_num ==null'> </span>
							<span v-if='item.chapter_num'>第<i>{{item.chapter_num}}</i>章</span>
							<span><i>{{item.c_score}}</i>分</span>
						</div>
					</div>

					<div class="forum_middle">
						<p>
							<img src="../../assets/img/ds01.png" alt="" v-if="item.gift == '流星'">
							<img src="../../assets/img/ds02.png" alt="" v-if="item.gift == '卫星'">
							<img src="../../assets/img/ds03.png" alt="" v-if="item.gift == '行星'">
							<img src="../../assets/img/ds04.png" alt="" v-if="item.gift == '恒星'">
							<img src="../../assets/img/ds05.png" alt="" v-if="item.gift == '慧星'">
							<img src="../../assets/img/ds06.png" alt="" v-if="item.gift == 'M78星云'">
							<img src="../../assets/img/ds07.png" alt="" v-if="item.gift == '银河系'">
							{{item.c_content}} </p>
						<img src="../../assets/img/xiaoxi.png" alt="" class="xiaoxi" @click="toReply(item.id,item.user_id,item.nickname,item.c_content)">
					</div>
					<div class="er_reply" v-if="item.child.length == 0 ? false : true">
						<div :class="!item.show_comment ? 'list_item threelist' : 'list_item'" v-for='(it,index1) in item.child' :key='it.id'>
							<p class="top_text">
								<span class="name">{{it.nickname}}</span>
								<span class="floor">{{index1+1}}楼</span>
							</p>
							<p class="time"><span class="er_reply_time">{{formatDateTime(it.createtime)}}</span></p>
							<p class="content">{{it.c_content}}</p>
						</div>
					</div>
					<div v-if="item.child.length > 3" @click="showCommentLou(index)" class="more_comment">
						<span>
							{{!item.show_comment ? '更多评论' : '收起评论'}}
						</span>
						<img src="../../assets/img/rightArrs.png" alt="">
					</div>
					<!-- <div class="forum_bottom">
						<div><span>2楼</span> <span>读者甜瓜</span></div>
					</div> -->
				</div>
				<div class="forumListItem" v-for='(item,index) in longLou' :key='index' v-if="selectValue == item.chapter_num"
				 @touchstart="showDeleteButton(item.id)" @touchend="emptyTime">
					<!-- 头像栏 -->
					<div class="forum_top">
						<div class="forum_top_left">
							<div class="userImg">
								<img :src="$api.$BASE_URL_img+item.avatar" alt="" @click.stop="readUserZlFn(item.user_id)">
								<div class="timeInfo">
									<span class="wname">{{item.nickname}}</span>
									<p><span>{{formatDateTime(item.createtime)}}</span>
										<!-- <span class="time">18:45:26</span> -->
									</p>
								</div>
							</div>
							<!-- <p class="bookName">《笑傲江湖》</p> -->
						</div>
						<div class="forum_top_right">
							<span v-if='item.chapter_num ==0|| item.chapter_num ==null'> </span>
							<span v-if='item.chapter_num'>第<i>{{item.chapter_num}}</i>章</span>
							<span><i>{{item.c_score}}</i>分</span>
						</div>
					</div>

					<div class="forum_middle">
						<p>
							<img src="../../assets/img/ds01.png" alt="" v-if="item.gift == '流星'">
							<img src="../../assets/img/ds02.png" alt="" v-if="item.gift == '卫星'">
							<img src="../../assets/img/ds03.png" alt="" v-if="item.gift == '行星'">
							<img src="../../assets/img/ds04.png" alt="" v-if="item.gift == '恒星'">
							<img src="../../assets/img/ds05.png" alt="" v-if="item.gift == '慧星'">
							<img src="../../assets/img/ds06.png" alt="" v-if="item.gift == 'M78星云'">
							<img src="../../assets/img/ds07.png" alt="" v-if="item.gift == '银河系'">
							{{item.c_content}} </p>
						<img src="../../assets/img/xiaoxi.png" alt="" class="xiaoxi" @click="toReply(item.id,item.user_id,item.nickname,item.c_content)">
					</div>
					<div class="er_reply" v-if="item.child.length == 0 ? false : true">
						<div :class="!item.show_comment ? 'list_item threelist' : 'list_item'" v-for='(it,index1) in item.child' :key='it.id'>
							<p class="top_text">
								<span class="name">{{it.nickname}}</span>
								<span class="floor">{{index1+1}}楼</span>
							</p>
							<p class="time"><span class="er_reply_time">{{formatDateTime(it.createtime)}}</span></p>
							<p class="content">{{it.c_content}}</p>
						</div>
					</div>
					<div v-if="item.child.length > 3" @click="showCommentLou(index)" class="more_comment">
						<span>
							{{!item.show_comment ? '更多评论' : '收起评论'}}
						</span>
						<img src="../../assets/img/rightArrs.png" alt="">
					</div>
					<!-- <div class="forum_bottom">
						<div><span>2楼</span> <span>读者甜瓜</span></div>
					</div> -->
				</div>
			</div>
			<div v-else class="data_null">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		<!-- 长评 -->
		<div class="newCommentBox" v-show="navActiveIndex == 2 ? true : false">
			<div class="forumListBox" v-if="longPing.length != 0 ? true : false">
				<div class="forumListItem" v-for='(item,index) in longPing' :key='index' v-if="selectValue == item.chapter_num"
				 @touchstart="showDeleteButton(item.id)" @touchend="emptyTime">
					<!-- 头像栏 -->
					<div class="forum_top">
						<div class="forum_top_left">
							<div class="userImg">
								<img :src="$api.$BASE_URL_img+item.avatar" alt="" @click.stop="readUserZlFn(item.user_id)">
								<div class="timeInfo">
									<span class="wname">{{item.nickname}}</span>
									<p><span>{{formatDateTime(item.createtime)}}</span>
										<!-- <span class="time">18:45:26</span> -->
									</p>
								</div>
							</div>
							<!-- <p class="bookName">《笑傲江湖》</p> -->
						</div>
						<div class="forum_top_right">
							<span v-if='item.chapter_num ==0|| item.chapter_num ==null'> </span>
							<span v-if='item.chapter_num'>第<i>{{item.chapter_num}}</i>章</span>
							<span><i>{{item.c_score}}</i>分</span>
						</div>
					</div>

					<div class="forum_middle">
						<p>
							<img src="../../assets/img/ds01.png" alt="" v-if="item.gift == '流星'">
							<img src="../../assets/img/ds02.png" alt="" v-if="item.gift == '卫星'">
							<img src="../../assets/img/ds03.png" alt="" v-if="item.gift == '行星'">
							<img src="../../assets/img/ds04.png" alt="" v-if="item.gift == '恒星'">
							<img src="../../assets/img/ds05.png" alt="" v-if="item.gift == '慧星'">
							<img src="../../assets/img/ds06.png" alt="" v-if="item.gift == 'M78星云'">
							<img src="../../assets/img/ds07.png" alt="" v-if="item.gift == '银河系'">
							{{item.c_content}} </p>
						<img src="../../assets/img/xiaoxi.png" alt="" class="xiaoxi" @click="toReply(item.id,item.user_id,item.nickname,item.c_content)">
					</div>
					<div class="er_reply" v-if="item.child.length == 0 ? false : true">
						<div :class="!item.show_comment ? 'list_item threelist' : 'list_item'" v-for='(it,index1) in item.child' :key='it.id'>
							<p class="top_text">
								<span class="name">{{it.nickname}}</span>
								<span class="floor">{{index1+1}}楼</span>
							</p>
							<p class="time"><span class="er_reply_time">{{formatDateTime(it.createtime)}}</span></p>
							<p class="content">{{it.c_content}}</p>
						</div>
					</div>
					<div v-if="item.child.length > 3" @click="showCommentPing(index)" class="more_comment">
						<span>
							{{!item.show_comment ? '更多评论' : '收起评论'}}
						</span>
						<img src="../../assets/img/rightArrs.png" alt="">
					</div>
					<!-- <div class="forum_bottom">
						<div><span>2楼</span> <span>读者甜瓜</span></div>
					</div> -->
				</div>
				<div class="forumListItem" v-for='(item,index) in longPing' :key='index' v-if="selectValue == 0"
				 @touchstart="showDeleteButton(item.id)" @touchend="emptyTime">
					<!-- 头像栏 -->
					<div class="forum_top">
						<div class="forum_top_left">
							<div class="userImg">
								<img :src="$api.$BASE_URL_img+item.avatar" alt="" @click.stop="readUserZlFn(item.user_id)">
								<div class="timeInfo">
									<span class="wname">{{item.nickname}}</span>
									<p><span>{{formatDateTime(item.createtime)}}</span>
										<!-- <span class="time">18:45:26</span> -->
									</p>
								</div>
							</div>
							<!-- <p class="bookName">《笑傲江湖》</p> -->
						</div>
						<div class="forum_top_right">
							<span v-if='item.chapter_num ==0|| item.chapter_num ==null'> </span>
							<span v-if='item.chapter_num'>第<i>{{item.chapter_num}}</i>章</span>
							<span><i>{{item.c_score}}</i>分</span>
						</div>
					</div>

					<div class="forum_middle">
						<p>
							<img src="../../assets/img/ds01.png" alt="" v-if="item.gift == '流星'">
							<img src="../../assets/img/ds02.png" alt="" v-if="item.gift == '卫星'">
							<img src="../../assets/img/ds03.png" alt="" v-if="item.gift == '行星'">
							<img src="../../assets/img/ds04.png" alt="" v-if="item.gift == '恒星'">
							<img src="../../assets/img/ds05.png" alt="" v-if="item.gift == '慧星'">
							<img src="../../assets/img/ds06.png" alt="" v-if="item.gift == 'M78星云'">
							<img src="../../assets/img/ds07.png" alt="" v-if="item.gift == '银河系'">
							{{item.c_content}} </p>
						<img src="../../assets/img/xiaoxi.png" alt="" class="xiaoxi" @click="toReply(item.id,item.user_id,item.nickname,item.c_content)">
					</div>
					<div class="er_reply" v-if="item.child.length == 0 ? false : true">
						<div :class="!item.show_comment ? 'list_item threelist' : 'list_item'" v-for='(it,index1) in item.child' :key='it.id'>
							<p class="top_text">
								<span class="name">{{it.nickname}}</span>
								<span class="floor">{{index1+1}}楼</span>
							</p>
							<p class="time"><span class="er_reply_time">{{formatDateTime(it.createtime)}}</span></p>
							<p class="content">{{it.c_content}}</p>
						</div>
					</div>
					<div v-if="item.child.length > 3" @click="showCommentPing(index)" class="more_comment">
						<span>
							{{!item.show_comment ? '更多评论' : '收起评论'}}
						</span>
						<img src="../../assets/img/rightArrs.png" alt="">
					</div>
					<!-- <div class="forum_bottom">
						<div><span>2楼</span> <span>读者甜瓜</span></div>
					</div> -->
				</div>
			</div>
			<div v-else class="data_null">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>
		<!-- <div class="comment_input" @click="jumpUrl"> -->
		<!-- v-show='!showReply' -->
		<div class="comment_input" @click="tostShow" style="z-index: 123" v-if="!showReply">
			<div class="input_hf" @click="tostShow" >
				<input type="text" style="z-index: 2" @focus="tostShow" placeholder="说点啥" />
				<!-- <img src="../../assets/img/sdadd.png" alt=""> -->
			</div>
			<span>发送</span>
		</div>
		<!-- <input type="text" placeholder="说点啥..."> -->
		<!-- </div> -->
		<!-- 回复框 -->
		<!-- <div class="reply" v-show='showReply'>
			<div class="replay_people">
				<p class="people_name"><span v-html="nickname"></span>:<span v-html="c_content"> </span></p>
				<div class="zan_img">
					<img src='../../assets/img/zan.png' />
				</div>
			</div>
			<div class="replay_inner">
				<div class="replay_text"><input ref="replyValue" placeholder="回复TA..." /></div>
				<div class="replay_right">
					<div class="zan_box">
						<img src='../../assets/img/ok.png' />
					</div>
					<div class="go_box" @click="goReply">
						<img src='../../assets/img/go.png' />
					</div>
				</div>
			</div>
		</div> -->
		<div class="comment_input" v-if="showReply">
			<div class="input_hf">
				<input type="text" v-model="comment_text" :placeholder="change_text" />
				<!-- <img src="../../assets/img/sdadd.png" alt=""> -->
			</div>
			<span @click="goReply">发送</span>
		</div>
		<!-- 弹窗 -->
		<!-- v-show="tostShowBox" -->
		<div class="tostBoxFather" v-if="tostShowBox == true">
			<div class="header_img">
				<img src="../../assets/img/pltost.png" alt="" />
			</div>
			<!-- <div class="dog_img">
				<img src="../../assets/img/dog.png" alt="" />
			</div> -->
			<div class="tostBoxson">
				<div class="yunjinbiBox">
					<div class="yunjinbi" :class="itemyunjinbi == index ? 'active': ''" v-for="(item, index) in yunjinbiList" :key="index"
					 @click="itemyunjinbiFn(index,item.txt,item.num)">
						<div class="yunjinbi_left">
							<img :src="item.imgUrl" alt="">
						</div>
						<div class="yunjinbi_right">
							<span>{{item.txt}}</span></br>
							<span v-if='item.num ==0'>{{item.jinbi}}</span>
							<span v-if='item.jinbi ==null'>{{item.num}}</span>
						</div>
					</div>
				</div>
				<div class="selecttost">
					<div><span class="autherName">
							<!-- <input type="text" v-model="userInfoUsername"> -->
							<van-field v-model="userInfoUsername" placeholder="昵称修改" input-align="left" />
						</span> <span @click="toggle" class="seleValue"><i v-model="queryTitle">{{queryTitle}}分</i><img src="../../assets/img/downarr.png"
							 alt=""></span></div>
					<ul v-show="selectItem" class="select_item">
						<li v-for="(item,index) in selectItemList" @click="query_select(index,item.txt)" :class="queryIndex == index ? 'activeQuery' : ''">
							<span>{{item.txt}}分</span>
							<span class="queryArr" v-if="queryIndex == index ? true : false"><img src="../../assets/img/query.png" alt=""></span>
						</li>
					</ul>
				</div>
				<div class="tost_say">
					<van-field v-model="tost_say" rows="1" autosize type="textarea" placeholder="说点啥..." />
					<!-- <textarea ref="getValue" placeholder="说点啥..." v-model="tost_say" style="resize: none;"></textarea> -->
					<!-- <img src="../../assets/img/smile.png" alt="" class="smileImg" /> -->
				</div>
				<div class="submitBox">
					<img src="../../assets/img/flower.png" alt="" class="flower">
					<button @click="jumpUrl">提交</button>
				</div>
			</div>
		</div>
		<!-- v-show="tostShowBox" -->
		<div class="mask" @click="onMask" v-if="tostShowBox == true"></div>
		
		<!-- 投诉弹框 -->
		<div class="luntantost" v-show="tostShowBoxTS  == true">
			<div class="luntantostbgc">
				<div @click.stop="forumSetFn" class="active">投诉</div>
		
			</div>
		</div>
		<div class='mask' v-show="tostShowBoxTS == true" @click="hideTost"></div>
		
	</div>
</template>

<script>
	import qs from 'qs';
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				tousuId: '',
				tostShowBoxTS: false,
				queryIndex: ' ', //排序选择
				queryTitle: '2',
				selectValue: '',
				selectIndex: 0,
				navActiveIndex: 0,
				showSelect: false,
				navlists: ["最新评论", "长楼", "长评"],
				showSelectLists: [],
				userInfo: {},
				commentValue: '',
				selectItem: false,
				itemShow: false,
				tostShowBox: false, //弹框
				showReply: false, //回复框
				selectItemList: [{
						txt: '2',
					},
					{
						txt: '1',
					},
					{
						txt: '0',
					},
					{
						txt: '-1',
					},
					{
						txt: '-2',
					},
				],
				yunjinbiList: [{
						txt: '流星',
						jinbi: '100云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds01.png')
					},
					{
						txt: '卫星',
						jinbi: '500云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds02.png')
					},
					{
						txt: '行星',
						jinbi: '1000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds03.png')
					},
					{
						txt: '恒星',
						jinbi: '2000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds04.png')
					},
					{
						txt: '彗星',
						jinbi: '5000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds05.png')
					},
					{
						txt: 'M78星云',
						jinbi: '10000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds06.png')
					},
					{
						txt: '银河系',
						jinbi: '100000云锦币',
						num: 0,
						imgUrl: require('../../assets/img/ds07.png')
					},
					{
						txt: '琼浆玉露',
						num: '20',
						imgUrl: require('../../assets/img/ds08.png')
					},
					{
						txt: '琼浆玉露',
						num: '60',
						imgUrl: require('../../assets/img/ds08.png')
					}
				],
				list_comment: [], //评论
				userInfo: {},
				List_id: '',
				pid: '',
				reply_id: '',
				content: '',
				theme: '',
				c_score: 2,
				nickname: '',
				c_content: '',
				flag: true, //查看更多
				book_id: '',
				chapter_id: 0, //章节
				coin: '', //打赏
				gift: '',
				itemyunjinbi: -1, //云锦币
				content: '',
				longPing: [], //长评
				longLou: [], //长楼
				tost_say: '',
				comment_text: '', //回复内容
				change_text: '评论TA...',
				userInfoUsername: '', //用户昵称
				get_c_score: [],
			}
		},
		created() {
			this.book_id = this.$route.query.book_id || this.$route.query.huatiTlId;
			this.chapter_id = this.$route.query.chapter_id;
			this.get_book_detail();
		},
		mounted() {
			// this.userInfoUsername = this.userInfo.username;
			this.selectIndex = this.$route.query.chapter_num || 0;
			this.selectValue = this.$route.query.chapter_num || 0;
			if (JSON.parse(window.localStorage.getItem('userInfoData')) != undefined) {
				this.userInfo = JSON.parse(window.localStorage.getItem('userInfoData'));
				this.userInfoUsername = this.userInfo.nickname;
			}

		},
		methods: {
			// 评论投诉接口
			forumSetFn() {
				if(this.tousuId != ''){
					this.$axios.post(this.$api.tousu,{
						id: this.tousuId,
					}).then(res =>{
						Toast(res.data.msg);
						this.tostShowBoxTS = false;
					})
				}
			},
			hideTost(){
				this.tostShowBoxTS = false;
			},
			showDeleteButton(id) {
				// this.show_ldBox = false;
				this.tousuId = id;
				clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
				this.Loop = setTimeout(function() {
					this.tostShowBoxTS = true;
				}.bind(this), 1000);
			},
			emptyTime() {
				clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
			},
			readUserZlFn(userId) {
				this.$router.push({
					path: '/dzzhuanlan',
					query: {
						user_id: userId
					}
				})
			},
			navActiveFn(index) {
				this.navActiveIndex = index;
			},
			showSelectBox() {
				this.showSelect = !this.showSelect
			},
			selectItemFn(value, index, id) {
				this.selectValue = value;
				this.selectIndex = index;
				this.chapter_id = id;
				this.showSelect = !this.showSelect;
			},
			back() {
				this.$router.push({
					path: '/bookinfo',
					query: {
						id: this.book_id
					}
				})
			},
			tostShow() {
        console.log(123123123)
				this.tostShowBox = !this.tostShowBox
			},
			onMask() {
				this.tost_say = '';
				this.tostShowBox = !this.tostShowBox;
			},
			toggle() {
				this.selectItem = !this.selectItem
			},
			query_select(index, txt) {
				console.log(index);
				// for(var i=0;i<this.get_c_score.length;i++){
				// 	if(this.get_c_score[i].chapter_num == this.selectValue){
				// 		if(this.get_c_score[i].c_score == this.c_score){
				// 			// this.c_score = 0;
				// 			this.queryTitle = 0;
				// 		}
				// 	}else{

				// 	}
				// }
				this.queryIndex = index;
				this.queryTitle = txt;
				this.c_score = txt;
				this.selectItem = !this.selectItem
			},
			itemyunjinbiFn(data, txt, num) {
				this.itemyunjinbi = data;
				if (this.itemyunjinbi == 0) {
					this.tost_say = "黑夜给了我黑色的眼睛，我却用来寻找流星~"
				} else if (this.itemyunjinbi == 1) {
					this.tost_say = "百年树人，十年树木，五年造卫星~"
				} else if (this.itemyunjinbi == 2) {
					this.tost_say = "千里之行，始于足下；万里星空，有辣么一颗小行星~"
				} else if (this.itemyunjinbi == 3) {
					this.tost_say = "苟有恒，不必三更起五更眠又有黑眼圈~"
				} else if (this.itemyunjinbi == 4) {
					this.tost_say = "盛年不重来，彗星难在寻"
				} else if (this.itemyunjinbi == 5) {
					this.tost_say = "逝者如斯夫，不舍星云"
				} else if (this.itemyunjinbi == 6) {
					this.tost_say = "不积跬步，无以至千里；不积小流，无以成银河~"
				} else if (this.itemyunjinbi == 7) {
					this.tost_say = '人间精品快乐汽水，九霄瑶池琼浆玉露'
				}

				if (txt == '琼浆玉露') {
					this.coin = ''
				} else {
					this.coin = txt
				}

				this.gift = num
			},
			// 去回复
			goReply() {
				this.add_comment();
				this.pid = ''
			},
			// 回复
			toReply(id, user_id, nickname, c_content) {
				this.pid = id
				this.reply_id = user_id
				this.nickname = nickname
				this.c_content = c_content;
				this.showReply = !this.showReply
				this.change_text = '回复' + nickname;
			},
			//展示更多评论
			showComment(index) {
				// 因为vue的机制，在渲染玩完成后新添加的数据要用$set
				if (!this.list_comment[index].show_comment) {
					this.$set(this.list_comment[index], 'show_comment', true);
				} else {
					// 当有了数据就用正常的取反就行了
					this.list_comment[index].show_comment = !this.list_comment[index].show_comment;
				}
			},
			//展示更多评论（长楼）
			showCommentLou(index) {
				// 因为vue的机制，在渲染玩完成后新添加的数据要用$set
				if (!this.longLou[index].show_comment) {
					this.$set(this.longLou[index], 'show_comment', true);
				} else {
					// 当有了数据就用正常的取反就行了
					this.longLou[index].show_comment = !this.longLou[index].show_comment;
				}
			},
			//展示更多评论（长评）
			showCommentPing(index) {
				// 因为vue的机制，在渲染玩完成后新添加的数据要用$set
				if (!this.longPing[index].show_comment) {
					this.$set(this.longPing[index], 'show_comment', true);
				} else {
					// 当有了数据就用正常的取反就行了
					this.longPing[index].show_comment = !this.longPing[index].show_comment;
				}
			},
			// 点击提交
			jumpUrl() {
				// if(this.userInfoUsername == ''){
				// 	this.userInfoUsername  = this.userInfo.nickname;
				// 	return false
				// }else{
				if (this.tost_say) {
					this.content = this.tost_say
					this.tostShowBox = !this.tostShowBox
					this.add_comment();
					this.tost_say = '';
				} else {
					console.log('请输入评论内容')
				}
				// }


			},
			add_comment() {
				let comment = {};
				if (this.get_c_score.length != 0) {
					for (var i = 0; i < this.get_c_score.length; i++) {
						if (this.get_c_score[i].chapter_num == this.selectValue) {
							if (this.get_c_score[i].c_score == this.c_score && this.get_c_score[i].user_id == JSON.parse(localStorage.getItem('userInfoData')).user_id) {
								this.c_score = 0;
							} else if (this.get_c_score[i].c_score != this.c_score) {
								comment = {
									chapter_id: this.chapter_id,
									book_id: this.book_id,
									coin: this.coin,
									gift: this.gift,
									pid: this.pid,
									// content:this.content,
									content: this.comment_text || this.tost_say,
									theme: this.theme,
									score: this.c_score,
									nickName: this.userInfoUsername,
								}
							}
						} else if (this.selectValue == 0) {
							if (this.get_c_score[i].chapter_num == 1) {
								if (this.get_c_score[i].c_score == this.c_score) {
									this.c_score = 0;
								} else if (this.get_c_score[i].c_score != this.c_score) {
									comment = {
										chapter_id: this.chapter_id,
										book_id: this.book_id,
										coin: this.coin,
										gift: this.gift,
										pid: this.pid,
										// content:this.content,
										content: this.comment_text || this.tost_say,
										theme: this.theme,
										score: this.c_score,
										nickName: this.userInfoUsername,
									}
								}
							}
						} else {
							comment = {
								chapter_id: this.chapter_id,
								book_id: this.book_id,
								coin: this.coin,
								gift: this.gift,
								pid: this.pid,
								// content:this.content,
								content: this.comment_text || this.tost_say,
								theme: this.theme,
								score: this.c_score,
								nickName: this.userInfoUsername,
							}

						}
					}
				} else {
					if (this.selectValue == 0) {
						comment = {
							chapter_id: this.chapter_id,
							book_id: this.book_id,
							coin: this.coin,
							gift: this.gift,
							pid: this.pid,
							// content:this.content,
							content: this.comment_text || this.tost_say,
							theme: this.theme,
							score: this.c_score,
							nickName: this.userInfoUsername,
						}
					} else {
						comment = {
							chapter_id: this.chapter_id,
							book_id: this.book_id,
							coin: this.coin,
							gift: this.gift,
							pid: this.pid,
							// content:this.content,
							content: this.comment_text || this.tost_say,
							theme: this.theme,
							score: this.c_score,
							nickName: this.userInfoUsername,
						}
					}
				}
				// this.$axios.post(this.$api.book_comment + '?' + qs.stringify(comment)).then(res => {
				// 	console.log(res.data.msg)
				// 	if (res.data.code == 1) {
				// 		this.$toast(res.data.msg);
				// 		this.get_book_detail();
				// 		this.comment_text = '';
				// 		this.change_text = '评论TA...';
				// 	} else {
				// 		this.$toast(res.data.msg);
				// 	}
				// })
				if (JSON.parse(localStorage.getItem('userInfoData')) != undefined) {
					console.log(comment, 'comment')
					this.$axios.post(this.$api.book_comment, comment).then(res => {
						console.log(res.data.msg)
						if (res.data.code == 1) {
							Toast(res.data.msg);
							this.get_book_detail();
							this.comment_text = '';
							this.change_text = '评论TA...';
						} else {
							Toast(res.data.msg);
						}
					})
				} else {
					Toast('请登录后操作');
					return false;
				}


			},
			//获取详情页 （is_long=1 长评，is_much==1，长楼）
			get_book_detail() {
				var t = this;
				t.$axios.post(`${t.$api.book_detail}?book_id=${t.book_id}`).then(res => {
					if (res.data.code == 0) {
						Toast(res.data.msg);
						return false;
					} else if (res.data.code != 0) {
						console.log(res)
						t.list_comment = res.data.data.comment_list; //最新评论
						t.showSelectLists = res.data.data.chapter_list;
						if (t.$route.query.chapter_id == undefined || t.chapter_id == 0) {
							t.chapter_id = t.showSelectLists[0].id;
						} else {
							t.chapter_id = t.$route.query.chapter_id;
						}
						var resdata = res.data.data.comment_list;
						t.longPing = [];
						t.longLou = [];
						// t.showSelectLists = [];
						for (var i = 0; i < resdata.length; i++) {
							t.get_c_score.push({
								c_score: resdata[i].c_score,
								chapter_num: resdata[i].chapter_num,
								user_id: resdata[i].user_id,
							})

							if (resdata[i].is_long == 1) {
								t.longPing.push(resdata[i]); //长评
							} else if (resdata[i].is_much == 1) {
								t.longLou.push(resdata[i]); //长楼
							}
						}
						// for(var i = 0; i < res.data.data.chapter_list.length; i++){
						// 	if (res.data.data.chapter_list[i].number != null) {
						// 		t.showSelectLists.push({
						// 			chapter_num: res.data.data.chapter_list[i].number
						// 		});
						t.showSelectLists.unshift({
							number: '0'
						});
						// 		var hash = {};
						// 		var showSelectLists = t.showSelectLists;
						// 		showSelectLists = showSelectLists.reduce(function(showSelectLists, current) {
						// 			hash[current.number] ? '' : hash[current.number] = true && showSelectLists.push(current);
						// 			return showSelectLists
						// 		}, [])

						// 		t.showSelectLists = t.sortBykey(showSelectLists, 'chapter_num');
						// 	}
						// }
					}
				})
			},
			sortBykey(ary, key) {
				return ary.sort(function(a, b) {
					let x = a[key]
					let y = b[key]
					return ((x < y) ? -1 : (x > y) ? 1 : 0)
				})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);

				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},

		}
	}
</script>

<style lang="less" scoped>
	.mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		z-index: 999;
		background-color: rgba(0, 0, 0, .4);
	}
// 书本评论投诉
	//弹窗
	.luntantost {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100vw;
		// height: 454px;
		background: url(../../assets/img/pltost.png) no-repeat;
		background-size: 100%;
		z-index: 99999;
	
		img {
			position: absolute;
			bottom: 40px;
			left: 0;
			width: 100%;
		}
	
		.luntantostbgc {
			margin-top: 124px;
			z-index: 10000 !important;
			background: url(../../assets/img/dog.png) no-repeat #fff;
			background-size: 70%;
			background-position: 60% 80%;
	
			div {
				line-height: 120px;
				text-align: center;
				color: #737373;
				font-size: 30px;
				/*px*/
				z-index: 1000 !important;
			}
	
			div.active {
				color: #ff4081;
			}
	
		}
	
	}
	.commentBox {
		height: 100vh;
		background-color: #fff;
		overflow: hidden;
		position: relative;
		color: #000;

		// 头部
		.header {
			height: 160px; //
			// background-color: #ff5d95;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88%;
			background-size: 100%;
			background-color: #ffffff;

			// border-bottom: 1px solid #f0f0f0;/*no*/
			.header_tit {
				margin-top: 80px;
				width: 100vw;
				// height: 80px;
				position: relative;

				.leftarrImg {
					img {
						position: absolute;
						top: 50%;
						left: 0px;
						transform: translateY(-50%);
						width: 40px;
						height: 40px;
					}
				}

				h4 {
					text-align: center;
					color: #000;
					font-size: 34px;
					/*px*/
					line-height: 80px;
					font-weight: normal;
				}

				.rightSelect {
					position: absolute;
					top: 50%;
					right: 16px;
					transform: translateY(-50%);
					background-color: #f0f0f0;
					border: 0;
					padding: 10px 20px;
					font-size: 28px;
					/*px*/
					border-radius: 5px;

					p {
						display: inline-block;
						color: #ff4081;
					}

					img {
						margin-left: 10px;
						vertical-align: middle;
						width: 20px;
					}
				}

				.selectItem {
					position: absolute;
					top: 100%;
					right: 16px;
					background-color: #fff;
					border: 1px solid #f0f0f0;
					/*no*/
					// -webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					// /*no*/
					// -moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					// /*no*/
					// box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
					// /*no*/
					line-height: 60px;
					z-index: 100;
					width: 160px;
					height: 360px;
					overflow: hidden;
					overflow-y: scroll;

					li {
						text-align: center;
						font-size: 28px;
						/*px*/
					}

					.active_color {
						color: #ff4081;
					}
				}

			}
		}

		//navbar
		.navBar {
			display: flex;
			justify-content: space-around;
			height: 80px;
			line-height: 80px;
			background-color: #fff;
			color: #1f1f1f;
			font-size: 32px;
			/*px*/
			border-bottom: 1px solid #f0f0f0;
			/*no*/
		}

		.active_navbar {
			color: #ff4081;
			font-weight: 600;
		}

		.newCommentBox {
			padding: 0 16px;
			background-color: #fff;
			padding-bottom: 150px;
			position: relative;
			height: calc(100vh - 380px);
			overflow-y: scroll;

			.data_null {
				img {
					position: absolute;
					top: 300px;
					left: 50%;
					transform: translateX(-50%);
					width: 160px;
				}
			}
		}

		//最新评论
		.newComment:last-of-type {
			border-bottom: 0;
		}

		//实时讨论
		.forumListBox {
			padding: 0 16px;

			.forumListItem:last-child {
				border-bottom: 0px;
			}

			.forumListItem {
				padding-bottom: 24px;
				border-bottom: 1px solid #f0f0f0;
				/*no*/
				background-color: #fff;
				padding-right: 10px;

				.forum_top {
					display: flex;
					padding: 24px 0;
					justify-content: space-between;
					padding-bottom: 14px;

					.forum_top_left {
						flex: 1;
						display: flex;
						justify-content: space-between;

						.userImg {
							overflow: hidden;
							display: flex;

							img {
								width: 80px;
								height: 80px;
								float: left;
								border-radius: 50%;
								border: 2px solid #f0f0f0;
								/*no*/
							}

							.timeInfo {
								color: #a3a3a3;
								flex: 1;

								.wname {
									display: inline-block;
									// line-height: 80px;
									padding-left: 24px;
									// float: right;
									color: #3d3d3d;
									font-size: 30px;
									/*px*/
								}

								p {
									padding-top: 10px;
									padding-left: 20px;

									.time {
										padding-left: 10px;
									}
								}
							}
						}
					}

					.forum_top_right {
						width: 180px;
						text-align: right;
						// line-height: 80px;
						// color: #b8b8b8;
						color: #737373;
						font-size: 28px;

						/*px*/
						span {
							padding-right: 10px;

							i {
								font-style: normal;
								color: #81c5f7;
							}
						}

						span:last-child {
							padding: 0;
						}
					}
				}

				.forum_middle {
					position: relative;

					p {
						color: #3d3d3d;
						line-height: 50px;
						width: 85vw;
						font-size: 30px;

						/*px*/
						img {
							width: 60px;
							display: block;
						}
					}

					.xiaoxi {
						position: absolute;
						right: 0;
						bottom: 0px;
						width: 40px;
					}
				}

				.er_reply {
					color: #767676;
					padding: 10px 30px;
					border-radius: 4px;

					.list_item {
						line-height: 50px;
						padding: 0 30px;
						box-sizing: border-box;
						border-bottom: 1px solid #fff;
						background-color: #f0f0f0;

						.top_text {
							width: 100%;
							display: flex;
							flex-direction: row;
							justify-content: space-between;

							.name {
								color: #3d3d3d;
							}

							.floor {
								color: #ff4081;
							}
						}

						.content {
							overflow: hidden;
							width: 100%;
							max-height: 95px;
							// word-break: break-word;
							// line-clamp: 1;
							// -webkit-line-clamp: 1;
							// display: -webkit-box;
							// -webkit-box-orient: vertical;
						}

						.time {
							width: 100%;
							display: flex;
							// justify-content: flex-end;


							.er_reply_time {
								font-size: 24px;
								/*px*/
								color: #848484;
								// margin-left: 20px;
							}
						}
					}

					.list_item:last-child {
						border-bottom: 0;
					}

					.threelist {
						display: none;
					}

					.threelist:nth-child(1) {
						display: block;
					}

					.threelist:nth-child(2) {
						display: block;
					}

					.threelist:nth-child(3) {
						display: block;
					}
				}

				.fix_height {
					height: 445px;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.more_comment {
					padding: 14px 10px;
					color: #666666;
					text-align: center;
					display: flex;
					flex-direction: row;
					justify-content: center;
					align-items: center;
					color: #ff4081;

					img {
						width: 25px;
						margin-left: 10px;
					}
				}

				.forum_bottom {
					padding-top: 10px;

					span {
						color: #a3a3a3;
						padding-right: 10px;
					}
				}
			}
		}

		// 说点啥
		.comment_input {
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 100vw;
			height: 80px;
			padding: 20px 0;
			background-color: #fff;
			border-top: 1px solid #f0f0f0;

			/*no*/
			.input_hf {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				width: 80%;
				margin-left: 16px;
				height: 80px;
				line-height: 80px;
				border-radius: 80px;
				// position: relative;
				border: 1px solid #fa7298;

				/*no*/
				input {
					width: 82%;
					background-color: transparent;
					padding-left: 20px;
					border-radius: 80px;
				}

				img {
					position: absolute;
					top: 50%;
					right: 20px;
					transform: translateY(-50%);
					width: 50px;
				}
			}

			span {
				text-align: center;
				position: absolute;
				top: 50%;
				right: 10px;
				transform: translateY(-50%);
				background-color: #fa7298;
				color: #fff;
				padding: 15px 30px;
				border-radius: 20px;
			}
		}

		// 回复框
		.reply {
			box-sizing: border-box;
			background-color: #fff;
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;

			.replay_people {
				display: flex;
				align-items: center;
				height: 80px;
				border-bottom: 1px solid #707070;
				/*no*/
				padding-left: 18px;

				.people_name {
					font-size: 24px;
					/*px*/
					color: #737373;
				}

				.zan_img {
					width: 54px;
					height: 58px;
					margin-left: 10px;

					img {
						width: 100%;
					}
				}
			}

			.replay_inner {
				height: 88px;
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-sizing: border-box;
				padding: 0 20px;

				.replay_text {
					width: 70%;
					height: 88px;

					input {
						height: 88px;
						border: none;
						font-size: 20px;
						width: 100%;

						&::-webkit-input-placeholder {
							/* placeholder颜色 */
							color: #737373;
							/* placeholder字体大小 */
							font-size: 20px;
						}
					}

				}

				.replay_right {
					display: flex;
					align-items: center;

					.zan_box {
						width: 88px;
						height: 69px;

						img {
							width: 100%;
						}
					}

					.go_box {
						width: 45px;
						height: 38px;
						margin-left: 20px;

						img {
							width: 100%;
						}
					}
				}
			}
		}

		// 弹窗
		.tostBoxFather {
			z-index: 1000;
			position: fixed;
			bottom: 0;
			left: 0;
			height: 1100px;
			width: 100vw;
			overflow: hidden;

			.header_img {
				position: absolute;
				top: 4px;
				left: 0;

				img {
					width: 100vw;
				}
			}

			// .dog_img{
			// 	img {
			// 		width: 80%;
			// 		position: absolute;
			// 		top: 30%;
			// 		left: 50%;
			// 		transform: translateX(-50%);
			// 		z-index:100;
			// 	}
			// }
			.tostBoxson {
				position: absolute;
				top: 128px;
				left: 0;
				background-color: #fff;

				// 云锦币
				.yunjinbiBox {
					overflow: hidden;
					padding: 20px 16px;
					padding-bottom: 0;
					height: 540px;
					background: url(../../assets/img/dog.png) no-repeat center;
					background-size: 85%;
					background-position: 99% 100%;

					.yunjinbi {
						width: calc((100vw - 88px) / 3);
						box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, .3);
						/*no*/
						border: 1px solid #fa7298;
						/*no*/
						padding: 20px 0px;
						text-align: left;
						margin-right: 20px;
						border-radius: 10px;
						float: left;
						margin-bottom: 20px;
						color: #3d3d3d;
						position: relative;
						height: 120px;

						.yunjinbi_left {
							img {
								width: 100px;
								position: absolute;
								top: 30%;
								left: 50%;
								transform: translate(-50%, -50%);
							}
						}

						.yunjinbi_right {
							// padding-left: 100px;
							padding-top: 55px;
							text-align: center;
						}
					}

					.yunjinbi.active {
						box-shadow: none;
						background-color: #fff8fa;

						color: #000000;
					}

					.yunjinbi:nth-child(3n) {
						margin-right: 0;
					}
				}

				.selecttost {
					background-color: #fff;
					position: relative;
					height: 80px;
					line-height: 80px;
					margin: 0 16px;
					border-bottom: 1px solid #f0f0f0;
					/*no*/
					font-size: 30px;

					div {
						width: 100%;
						display: flex;
						justify-content: space-between;

						// .autherName {
						// 	padding-right: 40px;
						// 	font-weight: 600;
						// 	color: #ff4081;
						// 	overflow: hidden;
						// 	input{
						// 		height: 76px;
						// 		line-height: 76px;
						// 		outline: none;
						// 		border: 0;
						// 	}
						// }
						.autherName {
							font-weight: 600;
							color: #ff4081;
							overflow: hidden;
							width: 30%;

							/deep/.van-cell {
								padding: 0;
								line-height: 80px;

								/deep/.van-field__body {
									input {
										color: #ff4081;
									}
								}
							}

							input {
								height: 76px;
								line-height: 76px;
								outline: none;
								border: 0;
								width: 200px;
							}
						}

						.seleValue {
							i {
								font-style: normal;
							}

							img {
								padding-left: 10px;
								width: 20px;
							}
						}
					}

					// 下拉框css
					ul.select_item {
						position: absolute;
						top: 80px;
						right: 2%;
						background-color: #fff;
						z-index: 100;
						border-radius: 5px;
						-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, .3);

						/*no*/
						li {
							width: 170px;
							padding: 0 20px;
							line-height: 60px;
							border-bottom: 1px solid #f0f0f0;
							/*no*/

							span {
								font-size: 28px;
								/*px*/
							}

							img {
								margin-left: 60px;
								width: 20px;
								height: 20px;
							}

							.queryArr {
								padding-left: 20px;
							}
						}

						.activeQuery {
							color: #ff4081;
							border-bottom: 4px solid #f0f0f0;
							/*no*/
						}
					}
				}

				//评论
				.tost_say {
					background-color: transparent;

					height: 160px;
					margin: 0 16px;
					padding: 20px 0;
					overflow: hidden;
					position: relative;
					border-bottom: 1px solid #f0f0f0;

					/*no*/
					.smileImg {
						position: absolute;
						bottom: 10px;
						right: 16px;

						img {
							width: 40px;
						}
					}

					textarea {
						border: 0;
						height: 100%;
						// padding: 20px 0;
						width: calc(100vw - 32px);
						background-color: transparent;
					}

					textarea::placeholder {
						font-size: 26px;
						/*px*/
						color: #3d3d3d;
					}

					.van-cell {
						padding: 0;
					}
				}

				//提交
				.submitBox {
					background-color: #fff;
					position: relative;
					text-align: center;
					margin-top: 50px;
					margin-bottom: 40px;

					.flower {
						position: absolute;
						top: -60px;
						left: 20%;
						width: 100px;
					}

					button {
						width: 90%;
						border: 0;
						border-radius: 10px;
						line-height: 80px;
						font-size: 32px;
						/*px*/
						background-color: #FF4081;
						color: #fff;
					}
				}
			}
		}

	}
</style>
